import polyglotI18nProvider from 'ra-i18n-polyglot'
import englishMessage from 'ra-language-english'

// Resource field names used wherever react-admin infers a label from a
// source (e.g. SortButton menu items) instead of an explicit label prop.
const messages = {
    ...englishMessage,
    resources: {
        integrations: {
            fields: {
                id: 'ID',
                long_name: 'Name',
                created_date: 'Created Date',
                type: 'Type',
            },
        },
    },
}

/**
 *  Allows language change across React Admin.
 *  See: https://github.com/marmelab/react-admin/blob/master/docs/Translation.md
 *  Uses: https://airbnb.io/polyglot.js/#options-overview
 */
export default polyglotI18nProvider(
    () => {
        return messages
    },
    'en',
    // We need this allowMissing to suppress warnings.
    // See https://github.com/marmelab/react-admin/blob/master/docs/Translation.md#silencing-translation-warnings
    { allowMissing: true }
)
